var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 769.04 791.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#10325f;}.cls-2{fill:none;stroke:#10325f;stroke-miterlimit:10;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_1",
    "data-name": "\\u5716\\u5C64 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 659.6,
    cy: 767.7,
    r: 6.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 577.39,
    cy: 720.04,
    r: 6.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 489.46,
    cy: 663.77,
    r: 6.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 398.02,
    cy: 596.69,
    r: 6.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 321.73,
    cy: 537.41,
    r: 6.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 253.15,
    cy: 443.69,
    r: 6.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 198.2,
    cy: 339.52,
    r: 6.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 160.61,
    cy: 248.05,
    r: 6.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 102.58,
    cy: 154.49,
    r: 6.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 32.9,
    cy: 50.98,
    r: 6.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 489.46,
    cy: 767.7,
    r: 6.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 398.02,
    cy: 700.03,
    r: 6.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 308.99,
    cy: 633.87,
    r: 6.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 240.41,
    cy: 550.14,
    r: 6.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 185.46,
    cy: 489.43,
    r: 6.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 141.5,
    cy: 389.49,
    r: 6.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 96.21,
    cy: 290.95,
    r: 6.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 32.9,
    cy: 206.23,
    r: 6.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 321.73,
    cy: 761.33,
    r: 6.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 234.04,
    cy: 700.03,
    r: 6.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 179.09,
    cy: 627.5,
    r: 6.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 122.39,
    cy: 556.51,
    r: 6.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 72.02,
    cy: 450.06,
    r: 6.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26.53,
    cy: 361.47,
    r: 6.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 160.61,
    cy: 754.96,
    r: 6.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 78.38,
    cy: 663.77,
    r: 6.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26.53,
    cy: 556.51,
    r: 6.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 32.9,
    cy: 754.96,
    r: 6.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 645.98,
    y1: 761.33,
    x2: 587.94,
    y2: 726.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 566.84,
    y1: 713.67,
    x2: 500.01,
    y2: 670.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 477.15,
    y1: 657.4,
    x2: 408.46,
    y2: 606.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 384.55,
    y1: 590.32,
    x2: 332.95,
    y2: 550.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 315.36,
    y1: 527.69,
    x2: 259.52,
    y2: 456.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 246.78,
    y1: 433.61,
    x2: 204.57,
    y2: 350.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 191.83,
    y1: 328.09,
    x2: 166.98,
    y2: 262.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 154.24,
    y1: 235.15,
    x2: 108.95,
    y2: 167.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 96.21,
    y1: 144.32,
    x2: 39.27,
    y2: 63.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 23.02,
    y1: 44.66,
    x2: -15.25,
    y2: 6.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 32.9,
    y1: 66.07,
    x2: 32.9,
    y2: 195.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 32.45,
    y1: 222.58,
    x2: 26.53,
    y2: 350.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: -41.4,
    y1: 468.43,
    x2: 60.29,
    y2: 451.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 26.08,
    y1: 570.23,
    x2: 33.35,
    y2: 743.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 24.8,
    y1: 766.03,
    x2: -37.65,
    y2: 818.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 147.87,
    y1: 758.07,
    x2: 46.3,
    y2: 754.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 21.49,
    y1: 745.86,
    x2: -35.97,
    y2: 688.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 16.87,
    y1: 366.9,
    x2: -39.54,
    y2: 386.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 22.75,
    y1: 207.82,
    x2: -24.66,
    y2: 185.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 89.84,
    y1: 279.73,
    x2: 39.27,
    y2: 217.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 92.9,
    y1: 160.86,
    x2: 44.54,
    y2: 201.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 154.24,
    y1: 257.75,
    x2: 108.95,
    y2: 286.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 102.58,
    y1: 302.59,
    x2: 135.13,
    y2: 377.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 131.59,
    y1: 402.23,
    x2: 84.75,
    y2: 443.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 64.55,
    y1: 437.32,
    x2: 32.45,
    y2: 372.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 64.55,
    y1: 462.63,
    x2: 32.34,
    y2: 546.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 78.38,
    y1: 462.63,
    x2: 116.02,
    y2: 543.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 118.85,
    y1: 570.23,
    x2: 84.75,
    y2: 649.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 68.72,
    y1: 653.43,
    x2: 32.9,
    y2: 567.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 72.02,
    y1: 675.41,
    x2: 39.27,
    y2: 743.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 215.12,
    y1: 700.03,
    x2: 89.84,
    y2: 670.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 225.68,
    y1: 709.64,
    x2: 172.73,
    y2: 748.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 147.87,
    y1: 745.96,
    x2: 84.75,
    y2: 678.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 227.67,
    y1: 688.6,
    x2: 185.46,
    y2: 640.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 128.76,
    y1: 570.23,
    x2: 166.98,
    y2: 621.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 169.61,
    y1: 631.95,
    x2: 90.61,
    y2: 661.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 191.83,
    y1: 345.89,
    x2: 147.87,
    y2: 383.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 246.78,
    y1: 450.06,
    x2: 191.83,
    y2: 483.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 145.37,
    y1: 398.73,
    x2: 179.41,
    y2: 480.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 179.09,
    y1: 497.8,
    x2: 130.11,
    y2: 550.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 234.04,
    y1: 558.76,
    x2: 185.46,
    y2: 621.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 311.85,
    y1: 540.59,
    x2: 253.15,
    y2: 550.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 299.54,
    y1: 627.5,
    x2: 246.78,
    y2: 559.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 321.73,
    y1: 550.14,
    x2: 308.99,
    y2: 621.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 300.12,
    y1: 640.24,
    x2: 240.41,
    y2: 693.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 310.75,
    y1: 753.78,
    x2: 243.26,
    y2: 706.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 309.46,
    y1: 764.41,
    x2: 175.46,
    y2: 758.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 166.98,
    y1: 767.7,
    x2: 203.43,
    y2: 826.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 154.66,
    y1: 767.74,
    x2: 116.02,
    y2: 824.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 39.27,
    y1: 767.86,
    x2: 82.18,
    y2: 826.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 315.15,
    y1: 773.37,
    x2: 284.54,
    y2: 826.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 327.46,
    y1: 773.67,
    x2: 355.35,
    y2: 824
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 478.74,
    y1: 759.98,
    x2: 402.45,
    y2: 708.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 391.65,
    y1: 709.64,
    x2: 333.85,
    y2: 754.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 486.11,
    y1: 779.48,
    x2: 466.8,
    y2: 825.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 499.77,
    y1: 777.02,
    x2: 549.32,
    y2: 819.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 565.57,
    y1: 726.41,
    x2: 502.09,
    y2: 763.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 652.13,
    y1: 774.92,
    x2: 607.65,
    y2: 822.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 668.84,
    y1: 774.07,
    x2: 761.08,
    y2: 806.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 489.46,
    y1: 674.24,
    x2: 489.46,
    y2: 754.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 478.07,
    y1: 670.14,
    x2: 407.4,
    y2: 697.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 391.65,
    y1: 693.66,
    x2: 315.36,
    y2: 640.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 321.73,
    y1: 748.59,
    x2: 313.78,
    y2: 648.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 477.55,
    y1: 769.47,
    x2: 333.78,
    y2: 763.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 398.02,
    y1: 685.09,
    x2: 398.02,
    y2: 609.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 384.55,
    y1: 603.06,
    x2: 321.73,
    y2: 627.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 293.09,
    y1: 633.87,
    x2: 191.83,
    y2: 627.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 185.46,
    y1: 499.56,
    x2: 179.09,
    y2: 615.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 230.95,
    y1: 543.77,
    x2: 191.83,
    y2: 498.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 250.3,
    y1: 456.43,
    x2: 242.46,
    y2: 537.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 240.41,
    y1: 443.69,
    x2: 152.48,
    y2: 395.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 160.61,
    y1: 259.8,
    x2: 141.5,
    y2: 377.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 93.51,
    y1: 303.47,
    x2: 75.71,
    y2: 437.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 35.16,
    y1: 355.1,
    x2: 84.75,
    y2: 301.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 16.08,
    y1: 356.78,
    x2: -15.42,
    y2: 328.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 16.02,
    y1: 552.33,
    x2: -30.59,
    y2: 511.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 16.3,
    y1: 565.12,
    x2: -37.99,
    y2: 606.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 26.08,
    y1: 216.42,
    x2: -24.55,
    y2: 256.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 147.87,
    y1: 244.56,
    x2: 43.96,
    y2: 209.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 22.59,
    y1: 58.77,
    x2: -15.93,
    y2: 88.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 108.17,
    y1: 556.51,
    x2: 39.27,
    y2: 556.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 172.73,
    y1: 489.43,
    x2: 84.75,
    y2: 456.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 643.16,
    y1: 770.9,
    x2: 505.77,
    y2: 770.9
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/BG_1.2dfa42b3fa073f9a7b98a4515fe3b062.svg";
export { ForwardRef as ReactComponent };